import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'
import NavPanel from '../components/navpanel'
import './index.css'

class Layout extends Component {
  state = {
    navPanelIsOpen: false,
  }
  toggleNavPanel = () => {
    this.setState({
      navPanelIsOpen: !this.state.navPanelIsOpen,
    })
  }
  render() {
    const { children, data, location } = this.props
    return (
      <div
        className={`${this.state.navPanelIsOpen ? 'navPanel-visible' : ''}  ${
          location.pathname === '/' ? 'landing' : ''
        }`}
      >
        <NavPanel
          isOpen={this.state.navPanelIsOpen}
          onToggleNavPanel={this.toggleNavPanel}
        />

        <div className={`page-wrapper`}>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              {
                name: 'description',
                content:
                  'Strategeist is a grand strategy game in which you play a national spirit and guide your country to greater glory. You will guide your country to glory. To do this, you must engage in diplomacy, guide technological progress, dominate unruly neighbors, and cultivate your economy, all while managing the specter of internal strife. Take on the mantle of a Strategeist and Haunt the Halls of History!',
              },
              { name: 'keywords', content: 'strategeist, strategy, game' },
            ]}
          />
          <Header
            siteTitle={data.site.siteMetadata.title}
            disablePinning={location.pathname !== '/'}
          />
          <div>{children()}</div>
          <Footer />
        </div>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js